import { InmateActivitySummary } from '@reliance/types/models/InmateActivity';
import React from 'react';
import { Link } from 'react-router-dom';
import { formatCurrency } from '../format/Currency';
import { formatDate } from '../format/DateTime';
import { formatPhoneNumber } from '../format/PhoneNumber';

const TYPE_DIRECTION = new Set([
  'Text Message - Inbound',
  'Text Message - Outbound',
]);

export type SummariesTableRow = InmateActivitySummary & {
  messages?: number;
  accountBalance?: number;
  messageBalance?: number;
  metaType?: string;
};

export type SummariesTableProps = {
  rows: SummariesTableRow[];
  summaryType: 'monthly' | 'daily';
  loading?: boolean;
};

const SummariesTable: React.FC<SummariesTableProps> = ({ rows, summaryType, loading }) => {
  const colCount = 6;

  return (
    <table className="table table-striped table-hover table-bordered">
      <thead>
        <tr>
          <th>Date</th>
          <th>Type</th>
          <th>Amount</th>
          <th>Messages Added/Consumed</th>
          <th>Account Balance</th>
          <th>Messages Remaining</th>
        </tr>
      </thead>
      <tbody>
        {loading && (
          <tr>
            <td colSpan={colCount} style={{ padding: '2rem' }}>
              <div className="d-flex justify-content-center align-items-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            </td>
          </tr>
        )}
        {!loading &&
          rows.map((row) => {
            const typeStr = String(row.type);
            const showGroupingDate = TYPE_DIRECTION.has(typeStr);
            const isNotification = row.metaType === 'Notification';
            const messagesCell = isNotification
              ? ''
              : (row.messages ?? row.count ?? '');
            const amountCell = isNotification ? '' : formatCurrency(Number(row.amount));
            const accountBalanceCell =
              row.accountBalance != null ? formatCurrency(row.accountBalance) : '';
            return (
              <tr key={row.id}>
                <td>{formatDate(row.date, true)}</td>
                <td>
                  {showGroupingDate && (
                    <span>
                      {formatDate(row.date, summaryType === 'monthly' ? 'MMMM YYYY' : 'YYYY-MM-DD')}{' '}
                    </span>
                  )}
                  <span>{typeStr}</span>
                  {row.customerName && (
                    <div className="small">
                      {row.customerName}
                      {row.customerAni && (
                        <>
                          <br />
                          <Link to={`/account/${encodeURIComponent(row.customerAni)}`}>
                            {formatPhoneNumber(row.customerAni)}
                          </Link>
                        </>
                      )}
                    </div>
                  )}
                  {row.phoneCard && (
                    <div className="small">
                      {typeStr !== 'Phonecard Load' && 'Phone Card: '}
                      {row.phoneCard}
                    </div>
                  )}
                </td>
                <td>{amountCell}</td>
                <td>{messagesCell}</td>
                <td>{accountBalanceCell}</td>
                <td>{row.messageBalance ?? ''}</td>
              </tr>
            );
          })}
      </tbody>
    </table>
  );
};

export default SummariesTable;
